import type { Torch } from "@/pages/caster/torches-data-entry/models/torches.models";
import { useHasPermission, type MenuOptionType } from "@dexteel/mesf-core";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";

export const useTorchesOptionsFunctions = ({
  newStrand,
  handleDeleteTorch,
}: {
  newStrand: (torch: Torch) => void;
  handleDeleteTorch: (torch: Torch) => void;
}) => {
  const hasPermissionTo = useHasPermission();
  const canAddRemoveLength = hasPermissionTo("AddRemoveBilletLength");

  const getMenuOptions = (data: Torch) => {
    let options: MenuOptionType[] = [];
    if (data) {
      options = options.concat([
        {
          name: "Add length",
          key: "add_length",
          disabled: !canAddRemoveLength,
          onClick: () => {
            if (!canAddRemoveLength) return;
            newStrand(data);
          },
          icon: <PlaylistAddIcon />,
        },
        {
          name: "Remove length",
          key: "remove_length",
          disabled:
            !canAddRemoveLength ||
            (data.HotLength !== null && data.HotLength <= 0),
          onClick: () => {
            if (!canAddRemoveLength) return;
            handleDeleteTorch(data);
          },
          icon: <DeleteIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
